import { CheckCircle } from "@mui/icons-material";
import { CircularProgress } from "@mui/material";
import { useState } from "react";



export default function SuccessfulScreen({message}) {

    const [showProgress, setShowProgress] = useState(true)
    const [showCheck, setShowCheck] = useState(false)
    
    setTimeout(() => {
        setShowProgress(false)
        setShowCheck(true)
    }, 0);
    
    return (
        <div className="mx-5 my-10 text-center">
            {(showProgress) &&
                <div>
                    <CircularProgress sx={{color: "teal"}} />
                </div>
            }
            {(showCheck) &&
                <div>
                    <CheckCircle style={{fontSize: 50}} className="text-green-500" />
                    <div>
                        {message}
                    </div>
                </div>
            }            
        </div>
    )
}
